@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    composes: twoColumn from "../../components/FAQsBlock/index.module.scss";
    display: grid;
    column-gap: 2%;
    grid-template-columns: 25rem 25rem;
    justify-content: center;
    padding: 2.25rem 0 3.9375rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }
}

.navLinks {
    display: flex;
    justify-content: flex-end;
    margin: 0.8125rem 1rem;
}

.otherCountryLink {
    align-items: center;
    color: var(--color-lobster);
    cursor: pointer;
    display: flex;
    font-size: 1.25rem;
    text-decoration: none;

    &::after {
        background-color: var(--color-lobster);
        content: "";
        display: inline-block;
        height: 18px;
        margin-right: 0.25rem;
        mask-image: url("../icons/chevron-right.svg");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 18px 18px;
        min-width: 18px;
    }

    &:hover {
        color: var(--color-black);

        &::after {
            background-color: var(--color-black);
        }
    }
}

.state {
    composes: question from "../../components/FAQsBlock/index.module.scss";
}

.content {
    composes: answer from "../../components/FAQsBlock/index.module.scss";
}

.list {
    gap: 1rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0;
    padding: 0;

    & li {
        list-style: none;
    }
}

.city {
    color: var(--color-lobster);
    font-size: 1.2rem;
    text-decoration: none;

    &:hover {
        color: var(--color-black);
    }
}
